// Video category filter
document.querySelectorAll('[data-filters]').forEach(function(group){
  var chips = group.querySelectorAll('.chip');
  var grid = document.querySelector('#' + group.dataset.filters);
  if(!grid) return;
  var cards = grid.querySelectorAll('.vcard');
  chips.forEach(function(c){
    c.addEventListener('click', function(){
      chips.forEach(function(x){ x.classList.remove('active'); });
      c.classList.add('active');
      var f = c.dataset.f;
      cards.forEach(function(v){
        v.style.display = (f === 'all' || v.dataset.cat === f) ? '' : 'none';
      });
    });
  });
});

// Scroll reveal
var io = new IntersectionObserver(function(entries){
  entries.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('in'); });
}, { threshold: .15 });
document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

// Feedbacks carousel
document.querySelectorAll('.press').forEach(function(section){
  var track = section.querySelector('.press-track');
  var dotsWrap = section.querySelector('.press-dots');
  if(!track || !dotsWrap) return;
  var cards = track.querySelectorAll('.press-card');
  if(!cards.length) return;

  cards.forEach(function(_, i){
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'press-dot' + (i === 0 ? ' active' : '');
    b.setAttribute('aria-label', 'Ir para depoimento ' + (i + 1));
    b.addEventListener('click', function(){
      cards[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    });
    dotsWrap.appendChild(b);
  });
  var dots = dotsWrap.querySelectorAll('.press-dot');

  var cardIO = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        var idx = Array.prototype.indexOf.call(cards, e.target);
        dots.forEach(function(d, i){ d.classList.toggle('active', i === idx); });
      }
    });
  }, { root: track, threshold: 0.6 });
  cards.forEach(function(c){ cardIO.observe(c); });

  var prev = section.querySelector('.press-arrow.prev');
  var next = section.querySelector('.press-arrow.next');
  var step = function(){ return cards[0].getBoundingClientRect().width + 22; };
  if(prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if(next) next.addEventListener('click', function(){ track.scrollBy({ left: step(), behavior: 'smooth' }); });
});
